import React from "react";
import { Mail, Phone, MessageCircle, MapPin, Linkedin, Facebook, Instagram, Twitter } from "lucide-react";
import { CONTACT, NAV_LINKS, CATEGORIES } from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <img src="/assets/babul-logo.jpeg" alt="Babul" className="w-12 h-12 rounded-full ring-1 ring-white/20 object-cover" />
              <div>
                <div className="font-display text-xl font-bold">Babul Corporation</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-gold">
                  Global Trade · Trusted Partnerships
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/70 leading-relaxed max-w-md">
              Indian merchant exporter supplying authentic branded FMCG products to
              importers, wholesalers and supermarket chains worldwide.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { Icon: Linkedin, href: "#", label: "LinkedIn" },
                { Icon: Facebook, href: "#", label: "Facebook" },
                { Icon: Instagram, href: "#", label: "Instagram" },
                { Icon: Twitter, href: "#", label: "Twitter" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  aria-label={s.label}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full bg-white/8 border border-white/10 flex items-center justify-center hover:bg-white hover:text-navy transition-colors"
                >
                  <s.Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
              Explore
            </div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/75 hover:text-white transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
              Categories
            </div>
            <ul className="space-y-2.5">
              {CATEGORIES.slice(0, 8).map((c) => (
                <li key={c.id}>
                  <a href="#products" className="text-white/75 hover:text-white transition-colors">
                    {c.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <MessageCircle className="w-4 h-4 mt-1 shrink-0" />
                <a href={`https://wa.me/${CONTACT.whatsappRaw}`} target="_blank" rel="noreferrer" className="hover:text-white">
                  {CONTACT.whatsapp}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white break-all">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 shrink-0" />
                <span>{CONTACT.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 shrink-0" />
                <span>{CONTACT.cityCountry}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10">
          <div className="rounded-2xl bg-white/[0.03] border border-white/8 p-5 lg:p-6 text-xs text-white/60 leading-relaxed">
            <span className="font-semibold text-white/85">Legal Notice: </span>
            Babul Corporation is an independent merchant exporter and supplier of
            genuine branded FMCG products sourced through authorized distribution
            channels. We are not the manufacturer or owner of the trademarks
            displayed on this website. All trademarks, brand names and logos remain
            the property of their respective owners and are used solely for
            identification of the products supplied.
          </div>

          <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
            <div>© 2026 Babul Corporation. All Rights Reserved.</div>
            <div className="flex gap-5">
              <a href="#" className="hover:text-white">Privacy Policy</a>
              <a href="#" className="hover:text-white">Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
